import React from 'react';
import './modal.css'; // Add specific styling for the modal

interface ModalLinkProps {
  id: number;
  label: string;
  onClick: (id: number) => void;
}

const ModalLink: React.FC<ModalLinkProps> = ({ id, label, onClick }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    onClick(id);
  };

  return (
    <div className='modal-link-box'><a href="#" onClick={handleClick} className='modal-link'>
      {label}
    </a></div>
  );
};

export default ModalLink;